export default "__VITE_ASSET__a5NfEyz3__"